import React from "react";
import { Link } from "gatsby";
import fl_logo from "../img/fl_logo.svg";
import elsi_logo from "../img/elsi_logo.jpg";
import efadp_logo5 from "../img/efadp_logo_color_05.jpg";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: ""
    };
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active"
            })
          : this.setState({
              navBarActiveClass: ""
            });
      }
    );
  };

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Logo">
              <img src={elsi_logo} alt="EFADP Logo" className="logo_EFADP" />
            </Link>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-wrapper">
              <div className="navbar-start has-text-centered">
                <Link className="navbar-item" to="/about">
                  About
                </Link>
                <Link className="navbar-item" to="/profile">
                  Profile
                </Link>
                <Link className="navbar-item" to="/research">
                  Research
                </Link>
                <Link className="navbar-item" to="/education">
                  Education
                </Link>
                <Link className="navbar-item" to="/news">
                  AstroNews
                </Link>
              </div>
              <div className="navbar-start has-text-centered">
                <Link className="navbar-item" to="/outreach">
                  Outreach
                </Link>
                <Link className="navbar-item" to="/conference">
                  Conference
                </Link>
                <Link className="navbar-item" to="/media">
                  Media
                </Link>
                <Link className="navbar-item" to="/story">
                  Story
                </Link>
                <Link className="navbar-item" to="/blog">
                  Blog
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
